import { render, staticRenderFns } from "./WPExpPanel.vue?vue&type=template&id=58135f70"
import script from "./WPExpPanel.vue?vue&type=script&lang=ts"
export * from "./WPExpPanel.vue?vue&type=script&lang=ts"
import style0 from "./WPExpPanel.vue?vue&type=style&index=0&id=58135f70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports